'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/postcss/node_modules/supports-color/browser.js
// module id = 633
// module chunks = 0 1